import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { addUrlWatchersToScopeForExplorer } from '../../app/spaces/Explorer/ExplorerUrlBindings';
import { RecentsSpaceOwnProps } from '../../app/spaces/RecentsSpace/RecentsSpace';
import { setURLParametersOrDefaultsForEnteringSpaceAndFetchContent } from '../../app/spaces/SpaceConfig/SiteSpaceConfigHelper';
import { SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Module } from '../Module';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { Telemetry } from '../services/TelemetryService';

export interface IRecentsSpaceScope extends ng.IScope {
  recentsSpaceProps: RecentsSpaceOwnProps;
}

export class RecentsSpaceCtrl {

  private currentPath: string;

  public static $inject = [
    '$location',
    '$scope',
    'BrowserTitleService',
    'TelemetryService',
    'AngularContextFactory',
  ];

  constructor(
    $location: ng.ILocationService,
    $scope: IRecentsSpaceScope,
    browserTitleService: BrowserTitleService,
    telemetryService: Telemetry,
    angularContextFactory: AngularContextFactory,
  ) {
    browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.recentsBrowserTitle() });

    const angularContext = angularContextFactory.create($scope);
    $scope.recentsSpaceProps = {
      telemetry: telemetryService,
      angularContext
    };

    // Must be done before any of the setting of sorts and defaults below
    appStore.dispatch(enterSpace({
      item: SpaceItemForNonEntitySpace,
      spaceType: 'recents',
      subspaceName: undefined
    }));

    appStore.dispatch(updateBreadcrumbs([]));

    const queryString = getQueryStringServiceFromAngular($location);
    this.currentPath = $location.path();
    const getPath = () => {
      return this.currentPath;
    };

    // need to reset all filters and sorts when entering the recents space
    setURLParametersOrDefaultsForEnteringSpaceAndFetchContent(appStore, $location);
    addUrlWatchersToScopeForExplorer({ $scope, $location, queryString, store: appStore, getPreviousPath: getPath }, {contentType: false, filters: true, sort: true});

    appStore.dispatch(requestSpaceContents());
  }
}

Module.instance().controller('RecentsSpaceCtrl', RecentsSpaceCtrl);
